import { HttpService } from '../../../services/http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { InvestmentsQueryParams } from '../../../shared/interfaces/investments-query-params';
import { environment } from '../../../../environments/environment';
import { Summary } from '../../../shared/interfaces/bank-response.interface';
import { InvestmentsDistinctFilterValuesInterface } from '../interfaces/investments-distinct-filter-values.interface';
import { InvestorInterface, InvestorsDistinctFilterValuesInterface } from 'src/app/shared/interfaces/Investors-distinct-filter-values.interface';
import { InvestorsQueryParams } from 'src/app/shared/interfaces/investors-query-params';
import { InvestorsResponseInterface } from 'src/app/shared/interfaces/Investors-response.interface';

@Injectable({ providedIn: 'root' })
export class InvestmentsHttpService extends HttpService {
  getInvestmentsFilterData(): Observable<InvestmentsDistinctFilterValuesInterface> {
    return this.http.get<InvestmentsDistinctFilterValuesInterface>(`${this.baseUrl}investments/distinct-filter-values`);
  }

  getCurrencyFilterData(): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}currencies`);
  }

  getFinancialStatementsData(params: Partial<InvestmentsQueryParams>): Observable<any> {
    return this.http.get<any>(`${environment.url}financial-statements/${params.investorId}`);
  }

  getInvestmentsSummary(params: Partial<InvestmentsQueryParams>): Observable<Summary> {
    return this.http.get<Summary>(`${environment.url}investments/summary`, {
      params: this.queryCleaner(params),
    });
  }

  getInvestmentsData(params: Partial<InvestmentsQueryParams>): Observable<any> {
    const baseUrl = environment.url + 'investments';
    return this.http.get<any>(baseUrl, {
      params: this.queryCleaner(params),
    });
  }

  getInvestorsFilterData(): Observable<InvestorsDistinctFilterValuesInterface> {
    return this.http.get<InvestorsDistinctFilterValuesInterface>(`${this.baseUrl}investments/distinct-filter-values`);
  }

  getInvestorById(id: string): Observable<any> {
    return this.http.get<any>(`${environment.url}investors/${id}`, { headers: this.getHeaders() });
  }

  getInvestorsData(params: Partial<InvestorsQueryParams>): Observable<InvestorsResponseInterface> {
    const baseUrl = environment.url + 'Investors';
    return this.http.get<InvestorsResponseInterface>(baseUrl, {
      params: this.queryCleaner(params),
    });
  }

  getInvestorsSummary(params: Partial<InvestorsQueryParams>): Observable<Summary> {
    return this.http.get<Summary>(`${environment.url}Investors/summary`, {
      params: this.queryCleaner(params),
    });
  }

  addInvestor(investorData: InvestorInterface): Observable<any> {
    return this.http.post(`${environment.url}investors`, investorData, { headers: this.getHeaders() });
  }
}
